// Lowercase all keys in an object
export const lowerCaseKeys = (obj) => {
  return Object.keys(obj).reduce((result, key) => {
    result[key.toString().toLowerCase().trim()] = obj[key];
    return result;
  }, {});
};
